module.exports = __webpack_public_path__ + "static/media/malousci.324f3ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/malousci.png
// module id = 436
// module chunks = 0